<template>
    <div id="bot" style="text-align:center;">
        <div>
            <img src="../assets/temp32.jpg" style="padding: 20px 0px;"/>
        </div>
        <div class="bot">
            <div class="botc">
                <div style="font-size:14px">
                    <img src="../assets/logo.png" style="width: 260px;"/>
                    
                </div>
                <div class="help-nav" v-for="(item,index) in abouts" :key="index">
                    <div class="help-nav-title" style="margin:5px;">{{item.title}}</div>
                    <ul>
                        <li v-for="(item1,index1) in item.data" :key="index1">
                            <el-link :href="item1.url" :underline="false" class="help-nav-con" >
                                {{item1.name}}
                            </el-link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div style="margin:15px;">{{companyName}}</div>
                    <div class="con">电话：
                        <span v-for="(item,index) in telephone" :key="index">
                            {{ item }}
                            <el-divider v-if="!(index+1 == telephone.length)" direction="vertical"></el-divider>
                        </span>
                    </div>
                    <div class="con">手机：
                        <span v-for="(item,index) in phone" :key="index">
                            {{ item }}
                            <el-divider v-if="!(index+1 == telephone.length)" direction="vertical"></el-divider>
                        </span>
                    </div>
                    <div class="con">传真：
                        {{ fax }}
                    </div>
                    <div class="con">Email：
                        {{ email }}
                    </div>
                    <div class="con">地址：
                        {{ adress }}
                    </div>
                </div>
            </div>
            <div class="cert">
                Copyright © 2010-2021 {{companyName}} All Rights Reserved 
                <el-link style="font-size: 12px;" :underline="false" href="https://beian.miit.gov.cn/">{{beian}}</el-link>
            </div>
        
        </div>

    </div>

</template>

<script>

import {index} from '../api';
export default {
  name: 'Bottom',
  data(){
      return {
        abouts:[
            {
                title:'关于商城',
                data:[
                    {name:'关于我们',url:'/about/aboutus'},
                    {name:'联系我们',url:'/about/contactus'},
                    {name:'用户协议',url:'/about/Agreement'},
                    {name:'发票须知',url:'/about/Invoice'},
                ]
            },
            {
                title:'最新动态',
                data:[
                    {name:'企业动态',url:'/about/CompanyNews'},
                    {name:'产品动态',url:'/about/ProductNews'},
                    
                ]
            },
            {
                title:'售后服务',
                data:[
                    {name:'投诉通道',url:'/about/Complaint'},
                    {name:'免责声明',url:'/about/Disclaimers'},
                ]
            },

        ],
        telephone:['0755-83210909','0755-83213361'],
        companyName:'深圳市毅创腾电子科技有限公司',
        phone:[],
        email:'',
        fax:'',
        adress:'',
        beian:'',
      }
  },
  created(){
    index({comp:'bot'}).then(res=>{
        this.telephone = res.telephone;
        this.companyName = res.cpname;
        this.phone = res.phone;
        this.fax = res.fax;
        this.email = res.email;
        this.adress = res.adress;
        this.beian = res.beian;
    })
  },
  components: {
    
  }
}
</script>

<style>
.cert{
    width:1190px;padding:15px 0px 0px 0px;margin:auto;
    border-top:1px solid #e1e1e1;
    color: #606266;font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.con{
    font-size: 14px;
    margin:15px;
}
.help-nav-con{
   margin: 5px;
   
}
.help-nav{
    width:150px;margin:10px;text-align: center;
}
.bot{
    background-color: white;
    padding: 30px 0px;width:100%;
    border-top: 1px solid #dedede;
}
.botc{
    background-color: white;width:1190px;
    margin: auto;
    text-align: left;
    display: flex;
    align-items: flex-start;
    padding:30px 0px;
}
@media screen and (max-width:1200px) {
        #bot{
            width:1190px;
        }
    }

</style>